import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faBell, faExclamationTriangle, faInfoCircle, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const InboxHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faInbox} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Inbox Guide</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>Stay updated with important news about your team, match results, player activities, and league events.</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faBell} style={{ marginRight: '8px', color: 'var(--info-color)' }} />News Types</h3>
            <p><strong>What you'll see in your inbox:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Match Results:</strong> Summary of your games and other league matches</li>
                <li><strong>Player News:</strong> Injuries, suspensions, form changes, milestones</li>
                <li><strong>Transfer Activity:</strong> Offers received, transfer market updates</li>
                <li><strong>Board Messages:</strong> Confidence changes, objectives, requests</li>
                <li><strong>League Updates:</strong> Schedule changes, cup draws, promotions</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Critical Alerts</h3>
            <p><strong>Important notifications to act on:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Injuries:</strong> Players who are unavailable for upcoming matches</li>
                <li><strong>Suspensions:</strong> Players banned from playing</li>
                <li><strong>Contract Expiry:</strong> Players about to leave - renew or sell</li>
                <li><strong>Board Issues:</strong> Low confidence warning - may lead to sacking</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Don't ignore critical alerts - they require immediate action</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Reading News</h3>
            <p><strong>Understanding your notifications:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Click on any news item to see full details</li>
                <li><strong>Mark as Read:</strong> Remove from unread count when you've reviewed</li>
                <li><strong>Date Stamps:</strong> See when events occurred</li>
                <li><strong>Unread Indicator:</strong> Red dot on Inbox icon shows unread messages</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Management Tips</h3>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Check your inbox regularly to stay on top of events</li>
                <li>Act quickly on injury reports - adjust your tactics</li>
                <li>Review contract expirations to avoid losing key players</li>
                <li>Pay attention to board confidence messages</li>
                <li>Use match reports to analyze your team's performance</li>
                <li>Watch for injury trends - may indicate fitness problems</li>
                <li>Keep inbox cleared to avoid missing important messages</li>
            </ul>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
